import { render, staticRenderFns } from "./PatientReestablishModal.vue?vue&type=template&id=a3b23f06&scoped=true"
import script from "./PatientReestablishModal.vue?vue&type=script&lang=js"
export * from "./PatientReestablishModal.vue?vue&type=script&lang=js"
import style0 from "./PatientReestablishModal.vue?vue&type=style&index=0&id=a3b23f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b23f06",
  null
  
)

export default component.exports